import React, {FunctionComponent} from 'react';

import Response from '../../../../../networking/models/Response';
import ResponseAnswer from '../../../../../networking/models/ResponseAnswer';
import University from '../../../../../networking/models/University';

interface Props {
    university: University;
    response: Response;
    answers: ResponseAnswer[];
}

const ResponseDetailContent: FunctionComponent<Props> = (props) => {

    return (
        <>
            <div className={'admin-response-detail-page__header'}>
                <h1 className={'admin-response-detail-page__title'}>Details</h1>
            </div>

            <div className={'admin-response-detail-page__content'}>
                <div>
                    <div className={'admin-response-detail-page__text-section'}>
                        <span className={'admin-response-detail-page__text admin-response-detail-page__text--bold admin-response-detail-page__text--title'}>{ props.response.first_name } { props.response.last_name }</span>
                        <span className={'admin-response-detail-page__text'}>{ props.response.email_han ?? props.response.email_private }</span>
                    </div>

                    <span className={'admin-response-detail-page__text admin-response-detail-page__text--bold'}>Studyprogramme</span>
                    <span className={'admin-response-detail-page__text'}>{ props.university.country?.name }</span>
                    <span className={'admin-response-detail-page__text'}>{ props.university.name }</span>
                    <span className={'admin-response-detail-page__text'}>{ props.university.city }</span>
                </div>

                <div>
                    { props.answers.map(answer => (
                        <div className={'admin-response-detail-page__answer'} key={answer.id}>
                            <span className={'admin-response-detail-page__text admin-response-detail-page__text--bold admin-response-detail-page__text--with-space'}>{ answer.question }</span>
                            <span className={'admin-response-detail-page__text'}>{ answer.answer }</span>
                        </div>
                    )) }
                </div>
            </div>
        </>
    );
};

export default ResponseDetailContent;
